import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { rvTrack } from 'track';
import { Toast } from 'patsnap-biz';
import { HOME_URI } from '@cores/constants/envConfig';
import { getFolderEmailAlertStatusApi, getEmailAlertLimitApi, } from '@cores/apis/others_api/email_alert';
import { injectService, provide } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export var EmailAlertDialogActType;
(function (EmailAlertDialogActType) {
    EmailAlertDialogActType["DETAIL"] = "DETAIL";
    EmailAlertDialogActType["NORMAL"] = "NORMAL";
})(EmailAlertDialogActType || (EmailAlertDialogActType = {}));
export const FolderEmailAlertServiceSymbol = Symbol.for('FolderEmailAlertService');
let FolderEmailAlertService = class FolderEmailAlertService {
    constructor() {
        this.alreadySetAlertFolderList = [];
        this.currentFetchedFolderId = null;
        this.isLoadingAlertStatus = true;
        this.isHasAlertFromService = false;
        this.currentFolderInfo = null;
        this.actionType = null;
        this.getEmailAlertStatus = _.debounce((folder_id) => {
            this.currentFetchedFolderId = folder_id;
            getFolderEmailAlertStatusApi(folder_id).then((res) => {
                this.isLoadingAlertStatus = false;
                this.isHasAlertFromService = !!res.length;
                if (this.isHasAlertFromService) {
                    this.alreadySetAlertFolderList = _.uniq([
                        ...this.alreadySetAlertFolderList,
                        folder_id,
                    ]);
                }
                else {
                    this.alreadySetAlertFolderList = _.filter(this.alreadySetAlertFolderList, (id) => id !== folder_id);
                }
            });
        }, 500);
    }
    get isHasAlert() {
        return this.isHasAlertFromService || this.alreadySetAlertFolderList.includes(this.currentFetchedFolderId);
    }
    init({ folder_id }) {
        if (folder_id !== this.currentFetchedFolderId) {
            this.isLoadingAlertStatus = true;
            this.currentFetchedFolderId = folder_id;
            if (folder_id) {
                this.getEmailAlertStatus?.(folder_id);
            }
        }
    }
    setAlertFolder(folder_ids = []) {
        this.alreadySetAlertFolderList.push(...folder_ids);
    }
    onEmailAlertAdded({ folderIds } = {}) {
        if (folderIds?.length) {
            this.setAlertFolder(folderIds);
        }
    }
    async open(folder) {
        const i18n = injectService(i18nSymbol);
        this.currentFolderInfo = folder;
        if (this.isHasAlert) {
            this.actionType = EmailAlertDialogActType.DETAIL;
        }
        else {
            const { alert_creation } = await getEmailAlertLimitApi();
            const alertLink = `${HOME_URI}/alert`;
            if (alert_creation && alert_creation > 0) {
                this.actionType = EmailAlertDialogActType.NORMAL;
            }
            else {
                Toast({
                    message: i18n.t('snapBusiness.emailAlert.alertLimitTip', { link: alertLink }),
                    type: 'warning',
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                });
            }
        }
        rvTrack('Click Detail Email Alert');
    }
    close() {
        this.currentFolderInfo = null;
        this.actionType = null;
    }
};
FolderEmailAlertService = __decorate([
    provide(FolderEmailAlertServiceSymbol),
    __metadata("design:paramtypes", [])
], FolderEmailAlertService);
export { FolderEmailAlertService };
